import { useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import BottomNav from "./BottomNav";
import TopBar from "./TopBar";
import NotifDrawer from "./NotifDrawer";
import FlowAmbience from "./FlowAmbience";

export default function AppShell({ children }) {
  const { user }  = useAuthStore();
  const isStudent = user?.role === "student";
  const { pathname } = useLocation();
  // Full-bleed pages (the Lernwelten hub) need room to breathe — not the mobile column.
  const wide = pathname.startsWith("/lernen");

  return (
    <div className="min-h-dvh bg-nexus-bg flex flex-col relative overflow-hidden">
      {/* ── Living canvas starfield (parallax stars + real shooting stars) ──── */}
      <FlowAmbience />

      {/* ── Ambient colour fields, layered OVER the starfield for depth ─────── */}
      <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 0 }} aria-hidden>
        {/* Aurora — three colour fields breathing against each other */}
        <div
          className="absolute rounded-full blur-[130px] opacity-[0.10]"
          style={{ width: 720, height: 520, top: "-8%", left: "-12%", background: "radial-gradient(ellipse, #8b5cf6, transparent 70%)", animation: "aurora-drift 16s ease-in-out infinite" }}
        />
        <div
          className="absolute rounded-full blur-[130px] opacity-[0.075]"
          style={{ width: 640, height: 520, bottom: "2%", right: "-12%", background: "radial-gradient(ellipse, #06b6d4, transparent 70%)", animation: "aurora-drift 20s ease-in-out infinite reverse" }}
        />
        <div
          className="absolute rounded-full blur-[140px] opacity-[0.05]"
          style={{ width: 540, height: 440, top: "40%", left: "56%", background: "radial-gradient(ellipse, #ec4899, transparent 70%)", animation: "aurora-drift 24s ease-in-out 4s infinite" }}
        />
        {/* Subtle dot grid */}
        <div
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: "radial-gradient(rgba(139,92,246,1) 1px, transparent 1px)",
            backgroundSize:  "30px 30px",
          }}
        />
        {/* Soft light beam falling from the top edge */}
        <div
          className="absolute inset-x-0 top-0 h-48 opacity-[0.06]"
          style={{ background: "linear-gradient(180deg, #8b5cf6, transparent)" }}
        />
        {/* Radial vignette so the edges sink into deep space */}
        <div
          className="absolute inset-0"
          style={{ background: "radial-gradient(ellipse 90% 75% at 50% 42%, transparent 55%, rgba(3,3,14,0.55) 100%)" }}
        />
      </div>

      <TopBar />

      <main className={`relative flex-1 overflow-y-auto ${isStudent ? "pb-24" : "pb-8"}`}>
        <div className={wide ? "page-enter" : "max-w-2xl mx-auto px-4 py-4 page-enter"}>
          {children}
        </div>
      </main>

      {isStudent && <BottomNav />}
      <NotifDrawer />
    </div>
  );
}
